import { render } from "./termsAndConditions.vue?vue&type=template&id=59254098"
import script from "./termsAndConditions.vue?vue&type=script&lang=js"
export * from "./termsAndConditions.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__